import { Controller } from "@hotwired/stimulus"
import { zip } from "fflate"
import { zipEntries } from "../lib/zip_entries"

// Store files without compressing them: the accepted types are mostly
// compressed already, and fflate only compresses large files in a blob: Web
// Worker, which the content security policy blocks.
function zipFiles(entries) {
  return new Promise((resolve, reject) => {
    zip(entries, { level: 0 }, (error, data) =>
      error ? reject(error) : resolve(data),
    )
  })
}

async function fetchFile({ url }) {
  const response = await fetch(url, { credentials: "same-origin" })
  if (!response.ok) throw new Error(`Download failed: ${response.status}`)
  return new Uint8Array(await response.arrayBuffer())
}

function save(blob, filename) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

export default class extends Controller {
  static targets = ["button", "status"]
  static values = {
    files: Array,
    filename: String,
    preparing: String,
    failed: String,
  }

  connect() {
    if (this.hasButtonTarget) this.buttonTarget.hidden = false
  }

  async download() {
    this.buttonTarget.disabled = true
    this.statusTarget.textContent = this.preparingValue

    try {
      const contents = await Promise.all(this.filesValue.map(fetchFile))
      const entries = zipEntries(this.filesValue, contents)

      save(
        new Blob([await zipFiles(entries)], { type: "application/zip" }),
        this.filenameValue,
      )
      this.statusTarget.textContent = ""
    } catch {
      this.statusTarget.textContent = this.failedValue
    } finally {
      this.buttonTarget.disabled = false
    }
  }
}
